<ng-container *transloco="let t; read: 'selectCompany'">
  <onep-header
    [stepper]="false"
    [displayHeaderLine]="false"
    class="select-company-header"
  >
    <onep-header-left>
      <img class="select-company-logo" [src]="gladyNoBorderUrl" alt="logo" />
    </onep-header-left>
  </onep-header>

  <img class="select-company-background" alt="" [src]="gridBgUrl" />
  <div onepLayout *ngIf="data">
    <div onepColumn [desktop]="2" [tablet]="4" [mobile]="2"></div>
    <div
      onepColumn
      [desktop]="8"
      [tablet]="4"
      [mobile]="2"
      class="select-company-full-content"
    >
      <div class="select-company-title">{{ t('title') }}</div>
      <div class="select-company-subtitle">
        {{ t('subTitle1') }}
        <span class="select-company-subtitle-mail">{{ data.login }}</span>
      </div>
      <div class="select-company-subtitle-2">
        {{ t('subTitle2') }}
        <span
          class="select-company-subtitle-disconnection"
          (click)="onLogoutClick()"
          >{{ t('subTitle2Disconnection') }}</span
        >
      </div>
      <div class="select-company-company-list-block">
        <div class="select-company-company-list-title">
          {{ t('blocTitle') }}
        </div>
        <div class="select-company-company-list-content">
          <onep-option-card
            *ngFor="let organization of data.managerOf; let i = index"
            class="address-bloc-card"
            (click)="switchCompany(organization.id, i)"
          >
            <onep-option-card-title>
              {{ organization.name }}
            </onep-option-card-title>
            <onep-option-card-content>
              {{ t('siret') }} {{ organization.siret }}
            </onep-option-card-content>
            <onep-option-card-conditions>
              <div>
                {{ formatFirstAddressBloc(organization.billingAddress) }}
                {{ formatSecondAddressBloc(organization.billingAddress) }}
              </div>
            </onep-option-card-conditions>
          </onep-option-card>
        </div>
      </div>
    </div>
    <div onepColumn [desktop]="2" [tablet]="4" [mobile]="2"></div>
  </div>
</ng-container>
